import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RestoreTag as RestoreTagMutation,
    RestoreTagVariables as RestoreTagVariables,
} from 'nutshell-graphql-types';

import RESTORE_TAG from '../mutations/restore-tag.graphql';

export function useRestoreTag(): {
    restoreTag: (arg1: {tagId: string}) => Promise<any>;
    isLoading: boolean;
    errorMessage: string | null | undefined;
} {
    const [restoreTagMutation, {loading, error}] = useMutation<
        RestoreTagMutation,
        RestoreTagVariables
    >(RESTORE_TAG);

    return {
        restoreTag: ({tagId}: {tagId: string}) =>
            restoreTagMutation({
                variables: {input: {tagId}},
            }),
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
}
